(() => {
  function init(root) {
    if (root.dataset.lightKitV3Ready) return;

    const strip = root.querySelector('[data-thumbnail-strip]');
    const previous = root.querySelector('[data-thumb-prev]');
    const next = root.querySelector('[data-thumb-next]');

    if (strip && previous && next) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const updateButtons = () => {
        const maximum = Math.max(0, strip.scrollWidth - strip.clientWidth);
        previous.disabled = strip.scrollLeft <= 3;
        next.disabled = strip.scrollLeft >= maximum - 3;
      };

      const move = direction => {
        const amount = Math.max(180, strip.clientWidth * 0.72);
        strip.scrollBy({
          left: direction * amount,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      strip.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons, { passive: true });
      requestAnimationFrame(updateButtons);

      root.querySelectorAll('[data-image-thumb]').forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          thumbnail.scrollIntoView({
            behavior: reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
          requestAnimationFrame(updateButtons);
        });
      });
    }

    const trustItems = Array.from(root.querySelectorAll('[data-trust-item]'));
    trustItems.forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        trustItems.forEach(other => {
          if (other !== item) other.open = false;
        });
      });
    });

    root.dataset.lightKitV3Ready = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-brkox-light-kit-v3]').forEach(init);
  }

  initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
